import { defineMessages } from 'react-intl';

const messages = defineMessages({
  otherButtonText: {
    description: 'Text for Other button',
    defaultMessage: 'Other...',
    id: 'euRs/r',
  },
  addFunds: {
    description: 'Call to action to purchase more funds',
    defaultMessage: 'Add Funds',
    id: '5/jUKh',
  },
  addFundsModalHeader: {
    description: 'Header for add funds confirmation modal',
    defaultMessage: 'Current Balance',
    id: 'NDFEdd',
  },
  addFundsNote: {
    description: 'Note to indicate the input is the amount of money they want to add',
    defaultMessage: 'Amount to Add',
    id: 'wRHCD5',
  },
  addFundsModalTitle: {
    description: 'Title from add funds modal',
    defaultMessage: 'ShipStation Balance',
    id: 'HyZhAk',
  },
  minimumFundsToAdd: {
    description: 'Note to user that there is a minimum purchase amount',
    defaultMessage: 'Minimum amount is {minimum}',
    id: '6PRxxt',
  },
  autoFundTitle: {
    description: 'Title for auto fund modal',
    defaultMessage: 'Manage Auto-Funding',
    id: 'CDpBkl',
  },
  autoFundBalance: {
    description: 'Auto fund balance note',
    defaultMessage: 'Auto-Fund Balance',
    id: '001tBU',
  },
  enableAutoFunding: {
    description: 'Text for enabling auto funding checkbox',
    defaultMessage: 'Automatically add funds to this balance',
    id: '4QCgVs',
  },
  balanceThreshold: {
    description: 'Note to indicate the balance threshold',
    defaultMessage: 'Add Funds if Below',
    id: 'WZr78V',
  },
  maxFunding: {
    description: 'Note to indicate the max amount of funds to add',
    defaultMessage: 'Max Funding',
    id: 'c9TrZb',
  },
  timesPerDay: {
    description: 'Note to indicate the times per day to add funds',
    defaultMessage: 'times per day',
    id: 'W2ive7',
  },
  saveButton: {
    description: 'Save button for auto fund modal',
    defaultMessage: 'Save',
    id: 'HAorG+',
  },
  makeDefault: {
    description: 'Label for default funding amount checkbox',
    defaultMessage: 'Make default funding amount',
    id: 'NH6J/D',
  },
  disclaimer: {
    description: 'Message in auto funding modal informing the user when auto funding will occur',
    defaultMessage: 'Auto-funding occurs when a label purchase causes your ShipStation balance to fall below your set threshold.',
    id: 'Ud5Wxf',
  },
  minimumThresholdFundsError: {
    description: 'Error to user that there is a minimum threshold amount bigger than zero',
    defaultMessage: 'Threshold must be greater than zero',
    id: '92Ps9q',
  },
  requiredThresholdFundsError: {
    description: 'Error message to the seller about the field is required',
    defaultMessage: 'Threshold is required',
    id: '8CsuZ5',
  },
});

export default messages;
